<script>
  import { defineComponent } from 'vue'
  const name = 'Paginador'

  export default defineComponent({
    name,

    components: {},

    props: {
      totalPaginas: {
        type: Number,
        default: 5,
      },
      maximoDePaginasVisiveis: {
        type: Number,
        default: 3,
      },
      reset: {
        type: Number,
        default: 0,
      }

    },

    emits: ['novaPagina'],

    mounted() { },

    updated() { },

    data() {
      return {
        ativo: 1,
        maximoPaginas: 3,
        paginaAtual: 1,
      }
    },

    methods: {
      clickPagina(pagina){
        if (pagina.desabilita) return;
        this.paginaAtual = pagina.name;
      },
    },

    computed: {
      paginaInicio(){
        if(this.paginaAtual === 1){
          return 1;
        }

        if(this.paginaAtual === this.totalPaginas){
          return this.totalPaginas - Math.min(this.maximoDePaginasVisiveis, this.totalPaginas) + 1;
        }

        return this.paginaAtual - 1;
      },

      paginaFinal(){
        return Math.min(this.paginaInicio + Math.min(this.maximoDePaginasVisiveis, this.totalPaginas) - 1, this.totalPaginas)
      },

      paginas(){
        const range = []
        for (let i = this.paginaInicio; i <= this.paginaFinal; i++){
          range.push({
            name: i,
            desabilita: i === this.paginaAtual
          })
        }
        return range;
      },

    },
    watch: {
      paginaAtual(){
        this.$emit('novaPagina', this.paginaAtual)
      },

      reset(){
        this.paginaAtual = 1
      }
    }
  })
</script>

<template>
  <div class="flex-container">
    <div class="botao-controle" @click="paginaAtual = 1">
      <img class="botaoTrocarPag" src="@/assets/imgs/angles-left-solid.svg" />
    </div>
    <div class="botao-controle" @click="paginaAtual = Math.max(1, paginaAtual - 1)">
      <img class="botaoTrocarPag" src="@/assets/imgs/angle-left-solid.svg" />
    </div>


    <div
      class="botao-pagina flex justify-center items-center"
      :class="{
        'ativo': p.desabilita == ativo
      }"
      v-for="(p) in paginas"
      @click="clickPagina(p)"
      :key="p"
    >
      {{ p.name }}
    </div>

    <div class="botao-controle" @click="paginaAtual = Math.min(totalPaginas, paginaAtual + 1)">
      <img class="rotate-180" src="@/assets/imgs/angle-left-solid.svg" />
    </div>
    <div class="botao-controle" @click="paginaAtual = totalPaginas">
      <img
        class="rotate-180"
        src="@/assets/imgs/angles-left-solid.svg"
      />
    </div>
  </div>
</template>

<style scoped>
.botaoTrocarPag {
  height: 50%;

}
.rotate-180 {
  height: 50%;
  transform: rotate(3.142rad);
}
.flex-container{
  width: 55%;
  gap:1%;
  align-content: center;
  display: flex;
}
  .botao-pagina {
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid #e6e4e4;
    width: 35px;
    height: 40px;
    border-radius: 7px;
    cursor: pointer;
    user-select: none;
  }

  .botao-controle {
    display: flex;
    justify-content: center;
    align-items: center;
    user-select: none;
  }

  .botao-pagina:active,
  .botao-pagina.ativo {
    border-color: #006cb7;
    color: #006cb7;
  }


</style>
